/**
 * EffectsToggle Component
 * Toggle for Effects panel
 */

import React from 'react';
import { Button } from '../../ui/button';
import { Sliders } from 'lucide-react';

export const EffectsToggle = ({
  showEffects,
  setShowEffects,
}) => {
  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={() => setShowEffects(!showEffects)}
      className={`p-2 ${showEffects ? 'text-indigo-400' : 'text-zinc-400'} hover:text-white`}
      data-testid="toggle-effects"
    >
      <Sliders className="w-5 h-5" />
    </Button>
  );
};

export default EffectsToggle;
